"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.responseSchema = exports.requestSchema = exports.irrigationFertigationSettingsGetInputSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.irrigationFertigationSettingsGetInputSchema = zod_1.default.object({
    propertyIds: zod_1.default.array(zod_1.default.number()).optional(),
});
exports.requestSchema = exports.irrigationFertigationSettingsGetInputSchema;
exports.responseSchema = zod_1.default
    .array(zod_1.default.object({
    farmId: zod_1.default.number(),
    propertyId: zod_1.default.number(),
    injectorSettings: zod_1.default.array(zod_1.default.object({
        externalTankId: zod_1.default.string(),
        fertilizerIds: zod_1.default.array(zod_1.default.string()),
        flowRate: zod_1.default.number(),
        flowRateUnit: zod_1.default.enum(['gal/min', 'l/h']),
        tankId: zod_1.default.number(),
        tankName: zod_1.default.string(),
    })),
    fertilizerSettings: zod_1.default.array(zod_1.default.object({
        externalTankId: zod_1.default.string(),
        fertilizerId: zod_1.default.number(),
        fertilizerName: zod_1.default.string(),
        tankId: zod_1.default.number(),
    })),
}))
    .or(zod_1.default.object({
    error: zod_1.default.string(),
}))
    .nullable();
exports.path = '/irrigation-fertigation-settings-get';
//# sourceMappingURL=index.js.map